export default class PolicyAcceptancePayload {
    constructor(
        public termsOfServiceAccepted: boolean,
        public privacyPolicyAccepted: boolean,
        public consentForMarketing: boolean,
        public uiContext: string | null = null
    ) { }
}
